import React from 'react';
import AboutFour from '../pages/AboutFour';
import Carousel from './Carousel';
import ServicesOne from '../pages/ServicesOne';
import WhyChooseOne from '../pages/WhyChooseOne';
import TaxiRatesOne from '../pages/TaxiRatesOne';
import TaxiBooking from '../pages/TaxiBooking';
import TestimonialsTwo from '../pages/TestimonialsTwo';
import DownloadAppThree from '../pages/DownloadAppThree';
import DownloadAppTwo from '../pages/DownloadAppTwo';
import TestimonialsThree from '../pages/TestimonialsThree';
import BlogOne from '../pages/BlogOne';
import CtaOne from '../pages/CtaOne';




const HeroSection = () => {

  return (


    <div className="th-hero-wrapper hero-1" id="hero">

<Carousel/>
<AboutFour/>
<ServicesOne/>
<WhyChooseOne/>
<TaxiRatesOne/>
{/* <TaxiBooking/> */}
<TestimonialsTwo/>
<DownloadAppTwo/>
{/* <TestimonialsThree/> */}
{/* <DownloadAppThree/> */}
<BlogOne/>
<CtaOne/>
    </div>
  );
};

export default HeroSection;
